export class ChangePasswordModel {
    public currentPassword: string;
    public newPassword: string;
    public confirm: string;
}



// WEBPACK FOOTER //
// ./src/models/account/change.password.model.ts